import { IListItemDetails, List, ListItem, ListSelection } from 'azure-devops-ui/List';
import { IProposedWorkItem } from '../../../types';
import {
  SingleLayerMasterPanel,
  SingleLayerMasterPanelHeader,
} from 'azure-devops-ui/MasterDetails';
import React, { useEffect, useState } from 'react';
import { Observer } from 'azure-devops-ui/Observer';
import { ArrayItemProvider, IItemProvider } from 'azure-devops-ui/Utilities/Provider';
import { Tooltip } from 'azure-devops-ui/TooltipEx';
import { Page } from 'azure-devops-ui/Page';
import { ObservableValue } from 'azure-devops-ui/Core/Observable';
import { bindSelectionToObservable } from 'azure-devops-ui/MasterDetailsContext';
import './ProposedWorkItemList.scss';
import { ProposedWorkItem } from './ProposedWorkItem';
import { ProposedWorkItemHeader } from './ProposedWorkItemHeader';
import { useCachingService } from '../../../hooks/useCachingService';
import { CachingService } from '../../../services/caching.service';
import { ZeroData } from 'azure-devops-ui/ZeroData';

export interface IProposedWorkItemListProps {
  extractedWorkItems: IProposedWorkItem[];
  onWorkItemCreated: (wi: IProposedWorkItem) => void;
}

const lastSelectedItem = 'lastProposedItem';

export function ProposedWorkItemList(props: IProposedWorkItemListProps) {
  console.log('loading proposed item list', props);
  const selection = new ListSelection({ selectOnFocus: false });
  const selectedItemObservable = new ObservableValue<IProposedWorkItem>(
    props.extractedWorkItems[0]
  );
  const itemProvider = new ArrayItemProvider(props.extractedWorkItems);
  const [count, setCount] = React.useState(0);
  const cache = useCachingService();

  const refreshComponent = () => {
    setCount(count + 1);
  };

  // TODO: reset the cache to 0 when a new transcription is done

  async function displayLastSelectedItem() {
    const last = await cache.getValue(lastSelectedItem);
    const lastIndex = parseInt(last ?? '0');
    selection.select(lastIndex);
  }

  useEffect(() => {
    bindSelectionToObservable(selection, itemProvider, selectedItemObservable);
    displayLastSelectedItem();
  });

  if (props.extractedWorkItems.length == 0)
    return (
      <ZeroData
        primaryText='No work items generated (yet).'
        imageAltText='No data'
        imagePath={require('../../../img/no-results.png')}
      />
    );

  return (
    <div className='proposed-work-item-list-container flex-row'>
      <SingleLayerMasterPanel
        className='proposed-work-item-list-panel show-on-small-screens'
        renderHeader={renderHeader}
        renderContent={() => renderContent(selection, itemProvider, cache)}
      />

      <Observer selectedItem={selectedItemObservable}>
        {(observerProps: { selectedItem: IProposedWorkItem }) => (
          <Page className='flex-grow single-layer-details'>
            {observerProps.selectedItem && (
              <ProposedWorkItem
                proposedWorkItem={observerProps.selectedItem}
                onWorkItemCreated={(workItemId) => {
                  props.onWorkItemCreated({
                    ...observerProps.selectedItem,
                    workItemId,
                    status: 'Created',
                  });
                  refreshComponent();
                }}
              />
            )}
          </Page>
        )}
      </Observer>
    </div>
  );
}

const renderHeader = () => {
  return <SingleLayerMasterPanelHeader title='Proposed Work Items' />;
};

const renderContent = (
  selection: ListSelection,
  itemProvider: IItemProvider<IProposedWorkItem>,
  cache: CachingService
) => {
  return (
    <List
      ariaLabel={'Commits Master Table'}
      itemProvider={itemProvider}
      selection={selection}
      renderRow={renderListItem}
      width='100%'
      singleClickActivation={true}
      onSelect={(event, row) => {
        cache.setValue(lastSelectedItem, row.index.toString());
      }}
    />
  );
};

const renderListItem = (
  index: number,
  item: IProposedWorkItem,
  details: IListItemDetails<IProposedWorkItem>,
  key?: string
): JSX.Element => {
  return (
    <ListItem
      className='master-example-row'
      key={key || 'list-item' + index}
      index={index}
      details={details}
    >
      <ProposedWorkItemHeader {...item} />
    </ListItem>
  );
};
